import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { PermissionsProvider } from './contexts/PermissionsContext';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PermissionsProvider>
      <App />
    </PermissionsProvider>
  </StrictMode>,
);
